import type { Policy } from '../types';

/** Whether this user falls inside a policy's acknowledgement audience */
export function inAckAudience(
  policy: Policy,
  staffCategory: string | undefined,
): boolean {
  if (!policy.requiresAcknowledgement) return false;
  if (policy.ackAudience === 'all') return true;
  return staffCategory === policy.ackAudience
    || (policy.ackAudience === 'teaching' && staffCategory === undefined);
}
